import Logger from "../utils/Logger";
import httpClient from "./httpClient";

function getFilenameFromHeader(disposition) {
  if (!disposition) return null;

  // Try filename* (RFC 5987/6266)
  let match = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (match && match[1]) {
    return decodeURIComponent(match[1].replace(/['"]/g, ""));
  }

  // Fallback to filename
  match = disposition.match(/filename\s*=\s*["']?([^;"']+)["']?/i);
  if (match && match[1]) {
    return match[1];
  }

  return null;
}

export async function downloadFile(
  url,
  onComplete = () => {},
  onProgress = null
) {
  try {
    const response = await httpClient.get(url, {
      withAuth: true,
      config: {
        responseType: "blob",
        onDownloadProgress: (ProgressEvent) => {
          if (!onProgress) {
            return;
          }

          const { loaded, total } = ProgressEvent;
          if (total) {
            const progress = Math.round((loaded * 100) / total);
            onProgress(progress);
          } else {
            onProgress(0);
          }
        },
      },
    });
    Logger.info("All response headers:", response.headers);
    const blob = response.data;
    // Axios puts headers in response.headers
    const disposition = response.headers["content-disposition"];
    const filename =
      getFilenameFromHeader(disposition) || "downloadedFile" || "plik";
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (err) {
    throw err;
  } finally {
    onComplete();
    onProgress(0);
  }
}
